import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "documents", "status"]

  connect() {
    this.timeout = null
  }

  debouncedSave(event) {
    if (event.target.type === "file") return

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.save(event), 500)
  }

  async save(event) {
    clearTimeout(this.timeout)

    if (event.target.type === "file" && event.target.files.length === 0) return

    this.setStatus("Saving...")

    try {
      const response = await fetch(this.formTarget.action, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: new FormData(this.formTarget),
        credentials: "same-origin"
      })

      const payload = await response.json()

      if (!response.ok) {
        throw new Error(payload.error || "Unable to save settings.")
      }

      if (payload.notification_documents_html) {
        this.documentsTarget.innerHTML = payload.notification_documents_html
      }

      this.setStatus(payload.message || "Saved")
    } catch (error) {
      this.setStatus(error.message || "Unable to save settings.")
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  setStatus(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
    }
  }
}
